import Constants from '../../constants/constants';
import { httpGet, httpPost } from '../api/axios_api';

export async function getMasquaradeUsers(search_terms) {
  const url = `${Constants.BACKEND_URL}/masquarade/users`;
  return httpGet(url, { params: { search_params: search_terms } });
}

export async function masquaradeUser(user_id) {
  const url = `${Constants.BACKEND_URL}/masquarade/user`;
  return httpPost(url, { user_id });
}

export async function revertMasquarade() {
  const url = `${Constants.BACKEND_URL}/masquarade/revert`;
  return httpGet(url, {});
}
